<div id="wrapper" [class.no-sidebar]="hideAllSidebars">
    <rsb-sidebar *ngIf="!hideAllSidebars && !hideMainSidebar && !hideSidebar && !hidePropertyBar"></rsb-sidebar>
    <app-company-sidebar *ngIf="!hideAllSidebars && hideMainSidebar"></app-company-sidebar>
    <app-project-sidebar *ngIf="!hideAllSidebars && hideSidebar"></app-project-sidebar>
    <app-propertysidebar *ngIf="!hideAllSidebars && hidePropertyBar"></app-propertysidebar>
    <div id="content-wrapper" class="d-flex flex-column">
        <div id="content">
            <rsb-header *ngIf="!hideAllSidebars"></rsb-header>
            <router-outlet></router-outlet>
        </div>
        <rsb-footer></rsb-footer>
    </div>
    <rsb-spinner></rsb-spinner>
</div>